import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './LoadingButton.css';


function LoadingButton({
  children,
  colorVariant,
  customContainerClass,
  disabled,
  fullWidth,
  isLoading,
  onClick,
  spinnerSize,
  ...props
}) {
  const containerClasses = classnames(
    {
      [styles.buttonContainer]: true,
      [styles.disabled]: Boolean(disabled),
    },
    customContainerClass
  );

  return (
    <div
      className={containerClasses}
      style={{ display: fullWidth ? 'block' : 'inline-block' }}
    >
      <Button
        classes={{
          root: isLoading ? styles.isLoading : styles[colorVariant],
          label: styles.label,
        }}
        disableRipple={true}
        disabled={isLoading ? !isLoading : disabled}
        fullWidth={fullWidth}
        onClick={onClick}
        {...props}
      >
        {children}
      </Button>
      {isLoading && (
        <CircularProgress
          className={styles.buttonProgress}
          size={spinnerSize}
        />
      )}
    </div>
  );
}

LoadingButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  colorVariant: PropTypes.oneOf(['orange', 'green', 'white', 'gray', 'none']),
  customContainerClass: PropTypes.string,
  disableRipple: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  spinnerSize: PropTypes.number,
  onClick: PropTypes.func,
};

LoadingButton.defaultProps = {
  children: null,
  className: undefined,
  colorVariant: 'orange',
  customContainerClass: undefined,
  disableRipple: false,
  disabled: false,
  fullWidth: false,
  spinnerSize: 24,
  size: 'medium',
  onClick: () => undefined,
};

export default LoadingButton;
